/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/lib/api";
import type {
  GetTeamsIdInviteTokenQueryResponse,
  GetTeamsIdInviteTokenPathParams,
  GetTeamsIdInviteToken401,
  GetTeamsIdInviteToken403,
  GetTeamsIdInviteToken404,
  GetTeamsIdInviteToken500,
} from "../types/GetTeamsIdInviteToken.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "@/shared/lib/api";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getTeamsIdInviteTokenQueryKey = (
  id: GetTeamsIdInviteTokenPathParams["id"] | undefined,
) => [{ url: "/teams/:id/invite/token", params: { id: id } }] as const;

export type GetTeamsIdInviteTokenQueryKey = ReturnType<
  typeof getTeamsIdInviteTokenQueryKey
>;

/**
 * {@link /teams/:id/invite/token}
 */
export async function getTeamsIdInviteToken(
  id: GetTeamsIdInviteTokenPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetTeamsIdInviteTokenQueryResponse,
    ResponseErrorConfig<
      | GetTeamsIdInviteToken401
      | GetTeamsIdInviteToken403
      | GetTeamsIdInviteToken404
      | GetTeamsIdInviteToken500
    >,
    unknown
  >({ method: "GET", url: `/teams/${id}/invite/token`, ...requestConfig });
  return res;
}

export function getTeamsIdInviteTokenQueryOptions(
  id: GetTeamsIdInviteTokenPathParams["id"] | undefined,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getTeamsIdInviteTokenQueryKey(id);
  return queryOptions<
    ResponseConfig<GetTeamsIdInviteTokenQueryResponse>,
    ResponseErrorConfig<
      | GetTeamsIdInviteToken401
      | GetTeamsIdInviteToken403
      | GetTeamsIdInviteToken404
      | GetTeamsIdInviteToken500
    >,
    ResponseConfig<GetTeamsIdInviteTokenQueryResponse>,
    typeof queryKey
  >({
    enabled: !!id,
    queryKey,
    queryFn: async ({ signal }) => {
      return getTeamsIdInviteToken(id!, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * {@link /teams/:id/invite/token}
 */
export function useGetTeamsIdInviteToken<
  TData = ResponseConfig<GetTeamsIdInviteTokenQueryResponse>,
  TQueryData = ResponseConfig<GetTeamsIdInviteTokenQueryResponse>,
  TQueryKey extends QueryKey = GetTeamsIdInviteTokenQueryKey,
>(
  id: GetTeamsIdInviteTokenPathParams["id"] | undefined,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<GetTeamsIdInviteTokenQueryResponse>,
        ResponseErrorConfig<
          | GetTeamsIdInviteToken401
          | GetTeamsIdInviteToken403
          | GetTeamsIdInviteToken404
          | GetTeamsIdInviteToken500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ?? getTeamsIdInviteTokenQueryKey(id);

  const query = useQuery(
    {
      ...getTeamsIdInviteTokenQueryOptions(id, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetTeamsIdInviteToken401
      | GetTeamsIdInviteToken403
      | GetTeamsIdInviteToken404
      | GetTeamsIdInviteToken500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
